import React, { Component } from 'react';
import '../style/loading.css';
import '../style/common.css';
import ES6Promise from 'es6-promise';
import ReactTable from "react-table";
import "react-table/react-table.css";
//import "bootstrap/dist/css/bootstrap.css";

ES6Promise.polyfill();

class Hotel_HotelRsvnEmailVcc extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false, keywords: "", searchResult: [], addEmail:"" };
    this.textboxOnChanged = this.textboxOnChanged.bind(this);
    this.btnSearchClick = this.btnSearchClick.bind(this);
    this.btnDeleteClick = this.btnDeleteClick.bind(this);
    this.btnAddClick = this.btnAddClick.bind(this);
  }

  textboxOnChanged(event) {
    console.log(event.target.value);
    this.setState({ [event.target.id]: event.target.value });
  }

  btnSearchClick(event) {
    this.setState({ isLoading: true, searchResult: [] });
    const fetch = require('isomorphic-fetch');
   
    var endpointUrl = process.env.REACT_APP_serverURL + "/Internal/searchrsvnemailvcc?keywords=" + encodeURI(this.state.keywords);

    fetch(endpointUrl, {
      method: "GET",
      headers: {},
    }).then(res => {
      this.setState({ isLoading: false });
      if (res.status === 401) {
        throw "401";
      }
      return res.json();
    }).then(
      rs => {
        for (var i = 0; i < rs.length; i++) {
          var obj = { email: rs[i], action: "" };
          this.state.searchResult.push(obj);
        }
        this.setState(this.state);
      },
      er => {
        console.log('error: ' + er);
      })
  }

  btnDeleteClick(event) {
    var email = this.state.searchResult[event.target.id].email;
    var id = event.target.id;
    this.setState({ isLoading: true });
    const fetch = require('isomorphic-fetch');

    var endpointUrl = process.env.REACT_APP_serverURL + "/Internal/ManageRsvnEmailVcc/DELETE?email=" + encodeURI(email);

    fetch(endpointUrl, {
      method: "GET",
      headers: {},
    }).then(res => {
      this.setState({ isLoading: false });
      if (res.status === 401) {
        throw "401";
      }
      return res.text();
    }).then(
      rs => {
        if (rs.indexOf("true") > -1) {
          this.state.searchResult.splice(id, 1);
          this.setState(this.state);
          alert("Record deleted!");
        }
        else
          alert("Fail to delete");
        console.log(rs);

      },
      er => {
        console.log('error: ' + er);
      })
  }

  btnAddClick(event) {
    var email = this.state.addEmail;    
    this.setState({ isLoading: true });
    const fetch = require('isomorphic-fetch');

    var endpointUrl = process.env.REACT_APP_serverURL + "/Internal/ManageRsvnEmailVcc/ADD?email=" + encodeURI(this.state.addEmail);

    fetch(endpointUrl, {
      method: "GET",
      headers: {},
    }).then(res => {
      this.setState({ isLoading: false });
      if (res.status === 401) {
        throw "401";
      }
      return res.text();
    }).then(
      rs => {
        if (rs.indexOf("true") > -1) {
          var obj = { email:email, action:""};
          this.state.searchResult.push(obj);
          this.setState(this.state);
          alert("Record added!");
        }
        else
          alert("Fail to add");
        console.log(rs);

      },
      er => {
        console.log('error: ' + er);
      })
  }

  render() {
    return (
      <form style={{ 'width': '700px', 'paddingTop': '5px', 'paddingLeft': '5px' }}>
        <div id="title" title="Rsvn Email(For VCC)">Rsvn Email(For VCC)</div>
        <div className="form-group row">
          <label htmlFor="keywords" className="col-sm-2 col-form-label">Email</label>
          <div className="col-sm-6">
            <input type="text" className="form-control" id="keywords" value={this.state.keywords} onChange={this.textboxOnChanged} />
          </div>
          <div className="col-sm-2">
            <button type="button" className="btn btn-info" onClick={this.btnSearchClick}>Search</button>
          </div>
          <div className="col-sm-2">
            <button type="button" className="btn btn-info" data-toggle="modal" data-target="#modalLoginForm" >Add</button>
          </div>
        </div>
        <div>
          <ReactTable
            data={this.state.searchResult}
            columns={[
              {
                Header: "",
                columns: [
                  {
                    Header: "Email",
                    accessor: "email",
                    width: 480
                  },
                  {
                    Header: "",
                    id: 'btnDelete',
                    Cell: ({ row, index }) => (<img id={index} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAO5JREFUSInt1L1OQkEQhuEHwZ8QYqyMhQ2dobAksfEKjIWNDTGx5wq8BGOBd+CdQGdiT0GFtQWVGo2KFLsmFJxzFihszptMsrOzs9/sLyUlczziOdoYpylJtSUEmjiM7XvspyRVcmLneMB79LfxOVfYNFpVWN3FEsWCDu4Sxh1hkBXM26IPXOOsQGALo4RCFvKEFho51sdx1gQbBQJT4Qx2sBn9XbzhAK/4if0rCfzRxSXauBUOdpCSmCqwMqVAIalfRU+4LV8YxvZJjFXwu47AFSYZsbrwR42zkqsFk0+wJ7zWRfaNG7wkFFryT8wAgJwl7A3dS5kAAAAASUVORK5CYII=" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) this.btnDeleteClick(e) }} />),
                    width: 50
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </div>
        <div className="modal fade" id="modalLoginForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">New Rsvn Email</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body mx-3">
                <div className="md-form mb-5 row">
                  <label htmlFor="addEmail" className="col-sm-2 col-form-label">Email</label>
                  <div className="col-sm-8">
                    <input type="text" className="form-control" id="addEmail" value={this.state.addEmail} onChange={this.textboxOnChanged} />
                  </div>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                  <button className="btn btn-default" onClick={this.btnAddClick}>Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          this.state.isLoading ? <div className="loadingMask" /> : ""
        }
      </form>);
  }
}

export default Hotel_HotelRsvnEmailVcc;
